import { Observable } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { matches } from 'rxjs-spy';

export class LayoutBreakpoints {
  private static bootstrapSmStart = 576;
  private static bootstrapMdStart = 768;
  private static bootstrapLgStart = 992;
  private static bootstrapXlStart = 1200;
  private static bootstrapXxlStart = 1400;
  private static minimumScreenEnd = 420;
  private static extraSmallScreenEnd = 500;
  private static smallScreenEnd = 1000;

  static bootstrapXsOrLess = `(max-width: ${this.bootstrapSmStart - 0.02}px)`;
  static bootstrapSmOrLess = `(max-width: ${this.bootstrapMdStart - 0.02}px)`;
  static bootstrapMdOrLess = `(max-width: ${this.bootstrapLgStart - 0.02}px)`;
  static bootstrapLgOrLess = `(max-width: ${this.bootstrapXlStart - 0.02}px)`;
  static bootstrapXlOrLess = `(max-width: ${this.bootstrapXxlStart - 0.02}px)`;

  static bootstrapSmOrMore = `(min-width: ${this.bootstrapSmStart}px)`;
  static bootstrapMdOrMore = `(min-width: ${this.bootstrapMdStart}px)`;
  static bootstrapLgOrMore = `(min-width: ${this.bootstrapLgStart}px)`;
  static bootstrapXlOrMore = `(min-width: ${this.bootstrapXlStart}px)`;
  static bootstrapXxlOrMore = `(min-width: ${this.bootstrapXxlStart}px)`;

  static minimumScreenOrLess = `(max-width: ${this.minimumScreenEnd}px)`;
  static extraSmallScreenOrLess = `(max-width: ${this.extraSmallScreenEnd}px)`;
  static smallScreenOrLess = `(max-width: ${this.smallScreenEnd}px)`;

  static landscape = '(orientation: landscape)';
  static portrait = '(orientation: portrait)';

  static tooSmallFor2Fields = ['(max-width: 545px)', `(min-width: ${this.bootstrapMdStart}px) and (max-width: 999px)`];

  static matches(breakpointObserver: BreakpointObserver, ... query :string[]): Observable<boolean> {
    return breakpointObserver.observe(query).pipe(map(match => match.matches));
  }
}
